module.exports = __webpack_public_path__ + "img/logo-papua.a54671fa.png";